// schema/nodes/icon.ts
import { HTMLBaseIcon } from "../../db/HTMLBaseIcon.js";
var ICON_SCHEMA = () => ({
  draggable: true,
  inline: true,
  atom: true,
  group: "inline",
  selectable: true,
  attrs: {
    data: { default: JSON.stringify(new HTMLBaseIcon({}).toObject()) },
    slot: { default: null }
  },
  parseDOM: [
    {
      tag: "node-icon",
      getAttrs: (dom) => ({
        data: dom.getAttribute("data"),
        "no-content": "true",
        contenteditable: "false",
        slot: dom.getAttribute("slot")
      })
    }
  ],
  toDOM: (node) => {
    return [
      "node-icon",
      {
        slot: node.attrs.slot,
        "no-content": "true",
        data: node.attrs.data,
        contenteditable: "false"
      }
    ];
  }
});
var ICON_KEY = "icon";
var ICON = {
  [ICON_KEY]: ICON_SCHEMA
};
export {
  ICON,
  ICON_KEY,
  ICON_SCHEMA
};
